<div class="modal fade" id="magicQuestionWriterModal" tabindex="-1" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content border-0 shadow-lg border-rounded-05">

            <!-- HEADER -->
            <div class="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <h5 class="modal-title text-zint-dark-blue text-bold-600 font-size-1-5">
                    <i class="far fa-sparkle .text-zint-dark-blue mr-2"></i>
                    Add Question to {{selectedModule?.key}}
                </h5>
                <button type="button" class="close text-grey-500 no-focus-outline" (click)="close()" [disabled]="isCreating">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <!-- BODY -->
            <div class="modal-body px-4 pb-4 pt-2">
                @if (!isCreating) {
                    <!-- INPUT STATE -->
                    <div class="row">
                        <div class="col-md-12">
                            <p class="text-grey-600 mb-3">
                                For superior results, ensure your question is specific and unambiguous. Avoid broad queries that could be interpreted in multiple ways.
                            </p>

                            <div class="status-badge-light-grey border-rounded-05 mb-3 p-2">
                                <i class="fal fa-book mr-2"></i>
                                <span>Read our guide on <a href="https://support.zint.io/hc/en-gb/articles/32563759347613-How-to-create-questions-and-generate-answers-to-Custom-Magic-Insights" target="_blank" class="text-dark u-offset-25">how to write effective Magic Insights questions</a>.</span>
                            </div>

                            <div class="form-group mt-4">
                                <label class="text-grey-700 text-bold-600">Your Question</label>
                                <textarea class="form-control rounded-input-base text-grey-700"
                                          rows="4"
                                          placeholder="e.g. Provide your best estimate of the number of parcels this company sends per month."
                                          [(ngModel)]="newQuestionText"></textarea>
                            </div>

                            <div class="d-flex justify-content-end align-items-center mt-4 pt-3 border-top border-light">
                                <button class="rounded-btn-base rounded-btn-light-outline btn-p-md mr-3" (click)="close()">
                                    Cancel
                                </button>
                                <button class="rounded-btn-base btn-p-lg shadow-sm rounded-btn-dark-cta"
                                        [disabled]="!newQuestionText || newQuestionText.length < 5"
                                        (click)="startCreation()">
                                    <i class="fal fa-magic mr-2"></i> Create Question
                                </button>
                            </div>
                        </div>
                    </div>
                } @else {
                    <!-- LOADING STATE -->
                    <div class="d-flex flex-column align-items-center justify-content-center py-5 min-height-25vh">

                        <div class="mb-4 position-relative">
                            <!-- Large custom spinner using Font Awesome duotone -->
                            <i class="fa-duotone fa-spinner-third fa-spin text-zint-dark-blue spinner-xl"></i>
                        </div>

                        <h4 class="text-zint-dark-blue text-bold-600 mb-2 text-center heartbeat-text">
                            {{ currentStepText }}
                        </h4>
                        <p class="text-grey-500 text-center">
                            This process usually takes about a minute. Please don't close this window.
                        </p>

                    </div>
                }
            </div>
        </div>
    </div>
</div>
